// ═══════════════════════════════════════════════════════════════
// PIXALLOY THEME — CSS-in-JS design tokens
// ═══════════════════════════════════════════════════════════════
export const V = {
  appBg:"#141414",panelBg:"#1e1e1e",panelRaised:"#252525",panelHover:"#2c2c2c",panelActive:"#333333",
  panelBorder:"#2e2e2e",panelBorder2:"#3a3a3a",text:"#d4d4d4",muted:"#737373",ghost:"#444",
  brand:"#0BC9F0",
  accent:"#2563eb",accentL:"#60a5fa",accentDim:"rgba(37,99,235,0.12)",
  mono:"'Fira Code',monospace",display:"'DM Serif Text',Georgia,serif",
};

export const optInputStyle = {
  background:V.panelActive,border:`1px solid ${V.panelBorder2}`,color:V.text,
  fontFamily:V.mono,fontSize:10,padding:"3px 8px",borderRadius:3,outline:"none",minWidth:52
};
